import { styled } from 'linaria/react';
import { BREAKPOINTS } from 'styles/constants';

export const StyledSection = styled.section`
  padding: 16px 0 64px;

  .hide-padding {
    margin-top: 12px;
  }
`;

export const StyledContent = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 56px;
  list-style: none;
  margin: 0;
  width: 100%;

  /* iOS Safari specific optimizations */
  @supports (-webkit-touch-callout: none) {
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    scroll-behavior: smooth;
  }

  /* General scroll optimizations */
  overflow-anchor: auto;
  min-height: 100vh;
`;

export const StyledGuestWrap = styled.div<{ hasOneItem: boolean }>`
  padding: 0 ${({ hasOneItem }) => (hasOneItem ? 12 : 0)}px;

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    padding: 0;

    .slider-info {
      padding: 0 24px 16px;
    }
  }
`;

export const StyledBlockWrap = styled.div`
  padding: 96px 0;
`;

export const StyledFeedbackWrap = styled.div`
  padding: 16px 24px;

  button {
    margin-top: 16px;
    width: 100%;

    /* iOS Safari specific optimizations */
    @supports (-webkit-touch-callout: none) {
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
      scroll-behavior: smooth;
    }

    /* General scroll optimizations */
    overflow-anchor: auto;
    min-height: 100vh;
  }
`;

export const StyledListWrap = styled.div<{ hasPadding: boolean }>`
  padding: 0 ${({ hasPadding }) => (hasPadding ? 12 : 0)}px;

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    padding: 0;
  }
`;

export const StyledCardWrap = styled.div`
  margin: 0 5%;
  padding: 16px 12px 0;

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    margin: 0 6%;
  }
`;

export const StyledRefreshLoader = styled.div<{ isRefreshing: boolean }>`
  display: flex;
  justify-content: center;
  padding: 16px 0;
  max-height: ${({ isRefreshing }) => (isRefreshing ? '100px' : '0')};
  opacity: ${({ isRefreshing }) => (isRefreshing ? '1' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease-out, opacity 0.3s ease-out, padding 0.3s ease-out;
  padding-top: ${({ isRefreshing }) => (isRefreshing ? '16px' : '0')};
  padding-bottom: ${({ isRefreshing }) => (isRefreshing ? '16px' : '0')};
`;

export const StyledSparkItem = styled.li`
  padding: 0 24px;
  list-style: none;
  margin-bottom: 56px;

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    padding: 0;
  }
`;
